import {
	useMutation,
	useQueryClient,
	type UseMutationOptions,
} from '@tanstack/react-query';
import {splitEventHandler} from '@netx/core-next/utils/fn';
import {GetAttributeVocabularyValuesReactQueryKey} from './useReactQueryGetAttributeVocabularyValues';
import {
	removeAttributeVocabularyValues,
	type RemoveAttributeVocabularyValuesResult,
	type RemoveAttributeVocabularyValuesRequestOptions,
	type QueryError,
} from '../removeAttributeVocabularyValues';

export * from '../removeAttributeVocabularyValues';

export type UseReactQueryRemoveAttributeVocabularyValuesOptions =
	UseMutationOptions<
		RemoveAttributeVocabularyValuesResult,
		QueryError,
		RemoveAttributeVocabularyValuesRequestOptions,
		RemoveAttributeVocabularyValuesResult
	>;

export const useReactQueryRemoveAttributeVocabularyValues = (
	options?: Omit<
		UseReactQueryRemoveAttributeVocabularyValuesOptions,
		'mutationFn'
	>,
) => {
	const queryClient = useQueryClient();

	return useMutation<
		RemoveAttributeVocabularyValuesResult,
		QueryError,
		RemoveAttributeVocabularyValuesRequestOptions,
		RemoveAttributeVocabularyValuesResult
	>({
		mutationFn: removeAttributeVocabularyValues,
		...options,
		onSuccess: splitEventHandler(
			options?.onSuccess,
			(data, variables, context) => {
				queryClient.invalidateQueries({
					queryKey: [
						GetAttributeVocabularyValuesReactQueryKey,
						{id: variables.vocabularyId},
					],
				});
			},
		),
	});
};

export default useReactQueryRemoveAttributeVocabularyValues;
